/** Installation history row for a meter. */
export interface InstallationData {
  date: number;
  dateParsed: string;
  serialNumber: string;
  state: number;
}

/** Installation state codes with their labels. */
export const INSTALLATION_STATE = {
  PENDING: 0,
  DONE: 1,
  0: "pending",
  1: "done",
};

/** Form data collected during meter activation. */
export class ActivationData {
  public serialNumber?: string;
  public rfModule?: string;
  public cups?: string;
  public comments?: string;
  public seal?: string;
  public photos?: { file: any; image?: any }[];
  public latitude?: number;
  public longitude?: number;

  constructor() {
    this.serialNumber = null;
    this.rfModule = null;
    this.cups = null;
    this.comments = null;
    this.seal = null;
    this.photos = [];
    this.latitude = 0;
    this.longitude = 0;
  }
}
